/** @typedef {import('../entities/AuditRunTrail.types').AuditRunFailure} AuditRunFailure */

/** Both written by functions/functions/ai/service/auditor/auditRunTrail.js. */
export const AUDIT_RUN_TRAIL_FIELD = 'noteAuditRun';

/** @type {Record<string, AuditRunFailure>} */
export const AUDIT_RUN_FAILURES = {
  FAILED: 'failed',
  DISCARDED: 'discarded',
};
